const getTimeZoneProps = (): {
  timeZone: string;
  signedAt: number;
} => {
  const fullDateStr: string = new Date().toString();
  const GMTIndex: number = fullDateStr.indexOf("GMT");
  const timeZone: string = fullDateStr.slice(GMTIndex, GMTIndex + 8);
  const signedAt: number = Date.now();

  return {
    timeZone,
    signedAt,
  };
};

export default getTimeZoneProps;
